import React from "react";
import { Grid, TextField } from "@mui/material";
import { NumericFormat, NumericFormatProps } from "react-number-format";

const Amount = (props: any) => {
	return (
		<Grid item xs={props.Size}>
			<TextField
				label={(props.NoLabel ? "" : props.Label ?? "Amount")}
				variant={props.Variant ?? "outlined"}
				className={`form-control border-app ${props.NoMB ? "" : "mb-3"} ${props.Class} col-${props.Size}`}
				value={props.Value === 0 ? null : props.Value}
				InputProps={{
					inputComponent: props.NoDollar ? NoDollarFormat as any : DollarFormat as any
				}}
				disabled={props.Disabled}
				onChange={props.OnChange} />
		</Grid>
	);
};

interface CustomProps {
	onChange: (event: { target: { name: string; value: string } }) => void;
	name: string;
}

const DollarFormat = React.forwardRef<NumericFormatProps, CustomProps>(
	function DollarFormat(props, ref) {
		const { onChange, ...other } = props;

		return (
			<NumericFormat
				{...other}
				getInputRef={ref}
				onValueChange={(values) => {
					onChange({
						target: {
							name: props.name,
							value: values.value,
						},
					});
				}}
				thousandSeparator
				valueIsNumericString
				prefix="$"
			/>
		);
	},
);

const NoDollarFormat = React.forwardRef<NumericFormatProps, CustomProps>(
	function DollarFormat(props, ref) {
		const { onChange, ...other } = props;

		return (
			<NumericFormat
				{...other}
				getInputRef={ref}
				onValueChange={(values) => {
					onChange({
						target: {
							name: props.name,
							value: values.value,
						},
					});
				}}
				thousandSeparator
				valueIsNumericString
			/>
		);
	},
);

export default Amount;